import { getContainer } from '@framework/di/getContainer';
import BondsRepository from '@/creditflowresearch/infrastructure/repository/BondsRepository';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';

export const useFilterApi = (
  setIsFetching: (isFetching: boolean) => void,
  setItems: (items: any) => void,
) => {
  const container = getContainer();
  const { currentAssetClass } = useBondsAssetClassesContext();

  const getBondsFilter = async (payload) => {
    setIsFetching(true);
    try {
      const filter = {
        ...payload,
        includedAssetClassId: currentAssetClass?.id,
      };
      const bondsRepository = container.get<BondsRepository>(BondsRepository);
      const response = await bondsRepository.getBondsFilter(filter);
      setItems(response);

      return response;
    } finally {
      setIsFetching(false);
    }
  };

  return {
    getBondsFilter,
  };
};
